import { useDisclosure } from "@mantine/hooks";
import { useApi } from "libs/data-access";
import React, { useEffect, useState } from "react";
import { showToast } from "utils/utility";

interface IIsEditing {
  type: "mobile" | "address 1" |  "address 2" | "password" | null;
  isEditing: boolean;
}
interface ForgotPasswordParams {
  password: string;
  confirmPassword: string;
}

function useProfile() {
  const getUser = JSON.parse(localStorage.getItem("user") || "{}");
  const { postData } = useApi();
  const [userProfile, setUserProfile] = useState<any>(null);
  const [mobile, setMobile] = useState<string>("");
  const [address1, setAddress1] = useState<string>("");
  const [address2,setAddress2]=useState<string>("")
  const [isEditing, setIsEditing] = useState<IIsEditing>({
    type: null,
    isEditing: false,
  });
  const [params, setParams] = useState<ForgotPasswordParams>({
    password: "",
    confirmPassword: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    setUserProfile(getUser?.value);
    setMobile(getUser?.value?.phoneNumber || "XXXXXXXXXX");
    setAddress1(getUser?.value?.address || "XXX XXX, XXXXXXXX, XXXXXX");
    setAddress2(getUser?.value?.address || "XXX XXX, XXXXXXXX, XXXXXX");
  }, []);

  const handleEditing = ({ type, isEditing }: IIsEditing) => {
    setIsEditing({ type, isEditing });
  };

  const handleParamsChange = (
    key: keyof ForgotPasswordParams,
    value: string,
  ) => {
    setParams((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const savePassword = async() => {
   const isValidated=validate();
   if(!isValidated) return;
    try {
      setIsLoading(true);
      const payload = {
        password: params.password,
        confirmPassword: params.confirmPassword,
      };
      console.log("Payload:",payload);
      const response =await postData("reset-password", payload);
      if(response.isSuccess){
        console.log("response:",response);
        handleEditing({type:null,isEditing:false})
      }
      else{
        console.error("Something went wrong")
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const validate=()=>{
    let isValidated=false;
    if(params.password !== params.confirmPassword){
        showToast({
            message:'Passwords do not match.',
            type:"warning"
        })
       isValidated=false; 
    }
    if(params.password === params.confirmPassword){
        isValidated=true;
    }
    return isValidated;
  }

  return {
    userProfile,
    mobile,
    setMobile,
    address1,
    setAddress1,
    address2,
    setAddress2,
    isEditing,
    handleEditing,
    params,
    setParams,
    handleParamsChange,
    isLoading,
    savePassword,
    isOpened,
    open,close,
  };
}

export default useProfile;
